"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seven/sections/appointmentSection.tsx */

import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AppointmentSection36sItem = {
    key: Key | null | undefined;
    /** Detected variants: "01. Choose Your Service" | "02. Pick a Doctor & Time" | "03. Enter Patient Details" | "04. Confirm & Pay" */
    h30Text: ReactNode;
    /** Detected variants: "Select the cardiology consultation or test you need." | "Browse specialists and choose a suitable appointment slot." | "Add your basic information and medical notes if any." | "Review your booking, make the payment, receive confirmation." */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-md-6 d-flex" */
    className?: string;
    /** Detected variants: "appointment-item flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeSevenAppointmentSectionGeneratedProps = {
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: AppointmentSection36sItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0Div0ClassName?: string;
    /** Default: "Book Your Appointment in Simple" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Four Steps" */
    sectionDiv0Div0Div0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div0Div1ClassName?: string;
    appointmentSection36s: AppointmentSection36sItem[];
    appointmentSection36sItemWrapper?: (item: AppointmentSection36sItem, content: ReactNode) => ReactNode;
    appointmentSection36sRenderer?: (defaultNode: ReactNode) => ReactNode;
    appointmentSection36sH3Visible?: boolean;
    appointmentSection36sH3Renderer?: (item: AppointmentSection36sItem, defaultNode: ReactNode) => ReactNode;
    appointmentSection36sH3Props?: Partial<ComponentProps<"h3">> | ((item: AppointmentSection36sItem) => Partial<ComponentProps<"h3">>);
};

const HomeSevenAppointmentSectionGenerated: FC<HomeSevenAppointmentSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0H20H2Text = "Book Your Appointment in Simple",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0SpanText = "Four Steps",
    divDiv0H30H3Props,
    sectionDiv0Div0Div0ClassName,
    sectionDiv0Div0Div1ClassName,
    appointmentSection36s,
    appointmentSection36sItemWrapper,
    appointmentSection36sRenderer,
    appointmentSection36sH3Visible,
    appointmentSection36sH3Renderer,
    appointmentSection36sH3Props,
}) => {
    return (
        <section className="appointment-section section">
            <div className="container">
                <div className="appointment-content">
                    <div className={sectionDiv0Div0Div0ClassName ?? "row"}>
                        <div className="col-xxl-6 col-md-8 mx-auto">
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H20H2Text}
                                    <span>{sectionDiv0Div0Div0Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                        </div>
                    </div>
                    <div className={sectionDiv0Div0Div1ClassName ?? "row"}>
                        {renderCollectionNode(
                            appointmentSection36s,
                            (item: AppointmentSection36sItem) => (
                                <div className={item.className ?? "col-xl-3 col-md-6 d-flex"} key={item.key}>
                                    <div className={item.div0ClassName ?? "appointment-item flex-fill"}>
                                        {renderItemNode(appointmentSection36sH3Visible, appointmentSection36sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof appointmentSection36sH3Props === "function" ? appointmentSection36sH3Props(item) : (appointmentSection36sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            ),
                            appointmentSection36sItemWrapper,
                            appointmentSection36sRenderer
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeSevenAppointmentSectionGenerated;
